var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 4.5H13.25C13.715 4.5 14.1275 4.515 14.495 4.5675C16.4675 4.785 17 5.715 17 8.25V9.75C17 12.285 16.4675 13.215 14.495 13.4325C14.1275 13.485 13.715 13.5 13.25 13.5H5.75C5.285 13.5 4.8725 13.485 4.505 13.4325C2.5325 13.215 2 12.285 2 9.75V8.25C2 5.715 2.5325 4.785 4.505 4.5675C4.8725 4.515 5.285 4.5 5.75 4.5Z",
    stroke: "currentColor",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2501 13.5C13.7151 13.5 14.1276 13.485 14.4951 13.4325C14.5026 13.5375 14.5026 13.635 14.5026 13.7475V14.0025C14.5026 15.9975 14.0001 16.5 11.9976 16.5H7.00256C5.00006 16.5 4.49756 15.9975 4.49756 14.0025V13.7475C4.49756 13.635 4.49756 13.5375 4.50506 13.4325C4.87256 13.485 5.28506 13.5 5.75006 13.5H13.2501Z",
    stroke: "currentColor",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00256 1.5H11.9976C14.0001 1.5 14.5026 2.0025 14.5026 3.9975V4.2525C14.5026 4.365 14.5026 4.4625 14.4951 4.5675C14.1276 4.515 13.7151 4.5 13.2501 4.5H5.75006C5.28506 4.5 4.87256 4.515 4.50506 4.5675C4.49756 4.4625 4.49756 4.365 4.49756 4.2525V3.9975C4.49756 2.0025 5.00006 1.5 7.00256 1.5Z",
    stroke: "currentColor",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderVertical);
export default __webpack_public_path__ + "static/media/slider-vertical.b0e6b5aef1cdf4652a16e7df536827aa.svg";
export { ForwardRef as ReactComponent };